export const useLightboxStore = defineStore("lightbox-store", () => {
  const isVisible = ref(false);
  const imgs = ref<(string | { src: string; title: string })[]>([]);
  const indexRef = ref(0);

  const showImg = (
    path: string | (string | { src: string; title: string })[],
    index: number = 0,
  ) => {
    if (typeof path === "string") {
      imgs.value = [path];
    } else {
      imgs.value = path;
    }
    indexRef.value = index;
    isVisible.value = true;
  };

  return {
    isVisible,
    imgs,
    indexRef,

    showImg,
  };
});
